import { render, staticRenderFns } from "./NatConOfficersAwardPreview.vue?vue&type=template&id=04b160d4"
import script from "./NatConOfficersAwardPreview.vue?vue&type=script&lang=js"
export * from "./NatConOfficersAwardPreview.vue?vue&type=script&lang=js"
import style0 from "./NatConOfficersAwardPreview.vue?vue&type=style&index=0&id=04b160d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports